import React, { useEffect, useRef, useState } from 'react';

//*MUI
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import axios from 'axios';

//*files
import ParkingFieldEntriesModal from '../ParkingFieldEntriesModal/ParkingFieldEntriesModal';
import cssClasses from './UploadParkingModal.module.css';

//*import npm
import * as XLSX from 'xlsx';
import { Typography } from '@mui/material';
import { errorTost, successTost } from '../../Services/Toast';
import Button from '../../Subcomponents/Button';
import { useParams } from 'react-router-dom';
import { element } from 'prop-types';
import { checkParkingInventory, insertIntoParkingInventory, updateParkingInventory } from '../../Services/Project';
import { orderBy } from 'lodash';
import { dismissLoader, presentLoader } from '../../Services/loader';
function UploadParkingModal({
  open,
  handleClose,
  uploadExcelFile,
  allParking,
  resVal,
  allParkingTypes,

}) {
  const [stepperValue, setStepperValue] = useState(1);
  const [parkingCsv, setParkingCsv] = useState(false);
  const { projectId } = useParams();
  const countRef = useRef(0);
  const [totalEntriesCount, setTotalEntriesCount] = useState(0);
  const [csvUploaded, setCsvUploaded] = useState(false);
  const [updateValCount, setUpdateValCount] = useState([]);
  const fieldServerEntriesArray = useRef([]);
  const newEntriesCount = useRef(0);
  // const [DatabaseEntries, setDatabaseEntries] = useState(0);
  const ParkingList = useRef([]);
  const [isFieldLocalEntriesModalOpen, setIsFieldLocalEntriesModalOpen] =
    useState(false);
  const [fieldLocalEntriesArray, setFieldLocalEntriesArray] = useState([]);
  const [isFieldEntriesModalOpen, setIsFieldEntriesModalOpen] = useState(false);
  const [updateCount, setUpdateCount] = useState(0);
  const [oldEntriesCount, setOldEntriesCount] = useState([]);
  const insertRef = useRef(0);


  useEffect(() => {
    //CountRef wasn't getting updated for New entries
    countRef.current = updateCount;
  }, [updateCount])

  const prevEntriesRef = useRef([]);

  useEffect(() => {
    function processParkingArray(parkingArray) {
      // Create a map to track unique keys and store duplicates
      const parkingMap = new Map();
      const duplicates = [];
      const seenDuplicates = new Set(); // To track which duplicates have been already added to the duplicates array

      // Function to generate a unique key for each parking object
      function generateKey(parking) {
        return `${parking.parkingTypeId}-${parking.floorNumber}-${parking.parkingLength}-${parking.parkingBreadth}-${parking.parkingHeight}`;
      }

      // Iterate through the array and process each parking object
      for (let i = 0; i < parkingArray.length; i++) {
        const parking = parkingArray[i];
        const key = generateKey(parking);

        if (parkingMap.has(key)) {
          // If the key exists in the map, it's a duplicate
          if (!seenDuplicates.has(key)) {
            // Add only the first duplicate to the duplicates array
            duplicates.push(parkingMap.get(key)); // Add the original entry
            seenDuplicates.add(key);
          }
          // Add the current duplicate to the duplicates array
          duplicates.push(parking);
          // Remove the duplicate from the original array
          parkingArray.splice(i, 1);
          i--; // Adjust index since array length has changed
        } else {
          // Otherwise, add the key to the map
          parkingMap.set(key, parking);
        }
      }

      return { remainingArray: parkingArray, duplicates };
    }

    const prevEntries = prevEntriesRef.current;
    const { remainingArray, duplicates } = processParkingArray(oldEntriesCount);
    // const duplicateParkingSlots = findDuplicates(oldEntriesCount);

    // Check if there are actual duplicates to avoid unnecessary updates
    if (duplicates && duplicates.length > 0) {
      const updatedEntriesCount = oldEntriesCount.filter(item => {
        const key = JSON.stringify(item);
        return !duplicates.some(dup => JSON.stringify(dup) === key);
      });

      setOldEntriesCount(updatedEntriesCount);
      // console.log("duplicateParkingSlots" , duplicates , fieldLocalEntriesArray)
      const payload = [
        ...fieldLocalEntriesArray,
        ...duplicates.map((m, i) => ({ ...m, id: i, reason: "Duplicate values are not allowed" }))
      ];
      // console.log("payload" , payload)
      setFieldLocalEntriesArray(payload);
    }

    // Update the ref with the latest entries
    prevEntriesRef.current = oldEntriesCount;

  }, [oldEntriesCount]);


  useEffect(() => {
    if (uploadExcelFile) {
      const reader = new FileReader();
      reader.onload = function (e) {
        var data = e.target.result;
        data = new Uint8Array(data);
        var workbook = XLSX.read(data, {
          type: 'array',
          cellText: false,
          cellDates: true,
        });
        var roa;
        workbook.SheetNames.forEach(function (sheetName) {
          roa = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[sheetName],
            { raw: false, dateNF: 'yyyy-mm-dd' }
          );
        });
        setTimeout(() => {
          // console.log(roa);
          validatingExcelData(roa);
        }, 1000);
      };
      reader.readAsArrayBuffer(uploadExcelFile);
    } else {
      errorTost('Please select valid excel file.');
    }

    return () => { };
  }, []);

  function validatingExcelData(_excelList) {
    const Val = _excelList.filter((f) => f?.["Parking Type"])
    setStepperValue(2);
    let getAllParkingResp = [...allParking, ...allParkingTypes];
    const invalidArr = [];
    ParkingList.current = [...getAllParkingResp];
    setTotalEntriesCount(Val.length)
    Val.forEach((element) => {
      element.floorNumber = element['Floor Number'];
      element.parkingNumber = element['Parking Number'];
      element.parkingBreadth = element['Parking breadth'];
      element.parkingHeight = element['Parking height'];
      element.parkingLength = element['Parking length'];
      element.description = element['Description']

      const validationResult = validateExcelObj(element);
      const validDataArr = [];
      if (!validationResult.validation.isValid) {
        invalidArr.push({
          ...element,
          reason: validationResult.validation.reason,
        });
        setFieldLocalEntriesArray(
          [...invalidArr].map((m, i) => ({ ...m, id: i }))
        );
      } else {
        validDataArr.push({ ...element });
      }
      let localValidExcelData = [];
      validDataArr.forEach((m) => {
        let elm = { ...m };
        const Inventory_ParkingType = getAllParkingResp.filter((f) => f.parkingTypeId.parkingType === m['Parking Type'])
        const Parking_type = getAllParkingResp.filter((f) => f.parkingType === m['Parking Type'])
        if (Inventory_ParkingType.length) {
          elm.parkingTypeId = Inventory_ParkingType[0]?.parkingTypeId?.parkingTypeId;
          localValidExcelData.push(elm)
        } else {
          elm.parkingTypeId = Parking_type[0]?.parkingTypeId;
          localValidExcelData.push(elm)
        }
      })
      uploadingDataToServer(localValidExcelData);
    });
  }

  async function uploadingDataToServer(_excelDataList) {
    setStepperValue(3);
    for (const parkingObj of _excelDataList) {
      const obj_check = {
        parkingNumber: parkingObj?.parkingNumber,
        projectId: projectId,
      }

      checkParkingInventory(obj_check?.parkingNumber, obj_check?.projectId).then(async (res) => {
        const payload = {
          parkingTypeId: parkingObj?.parkingTypeId,
          floorNumber: parkingObj?.floorNumber,
          parkingNumber: parkingObj?.parkingNumber,
          projectId: projectId,
          parkingBreadth: parkingObj?.parkingBreadth,
          parkingHeight: parkingObj?.parkingHeight,
          parkingLength: parkingObj?.parkingLength,
          description: parkingObj?.description,
        }

        const latestVal = orderBy(res.data, 'created_at', ['desc'])
        const isMatch = (val, obj) =>
          val?.parkingNumber == obj?.parkingNumber &&
          (val?.parkingTypeId == obj?.parkingTypeId?.parkingTypeId || val?.parkingTypeId == obj?.parkingTypeId) &&
          val?.floorNumber == obj?.floorNumber;

        const isSizeMatch = (val, obj) =>
          val?.parkingHeight === Number(obj?.parkingHeight) &&
          val?.parkingBreadth === Number(obj?.parkingBreadth) &&
          val?.parkingLength === Number(obj?.parkingLength) &&
          val?.description === obj?.description



        // console.log("isMatch" ,isMatch(latestVal[0], parkingObj))
        if (res.data.length > 0 && isMatch(latestVal[0], parkingObj)) {
          // console.log("isSizeMatch" ,isSizeMatch(latestVal[0], parkingObj) )
          if (isSizeMatch(latestVal[0], parkingObj)) {
            // console.log("all values match");
            setOldEntriesCount(prevEntries => {
              const updatedEntries = [...prevEntries, parkingObj];
              // console.log("update_entries", updatedEntries);
              return updatedEntries;
            });




          } else if (!isSizeMatch(latestVal[0], parkingObj) && latestVal[0]?.parkingStatusId.status === "Alloted") {
            // console.log("type is allotted");

            setOldEntriesCount(prevEntries => {
              const updatedEntries = [...prevEntries, parkingObj];
              // console.log("update_entries", updatedEntries);
              return updatedEntries;
            });
          } else if (!isSizeMatch(latestVal[0], parkingObj) && latestVal[0]?.parkingStatusId.status === "Available") {
            // console.log("type is available")
            if (latestVal[0]?.parkingHeight !== parkingObj?.parkingHeight ||
              latestVal[0]?.parkingBreadth !== parkingObj?.parkingBreadth ||
              latestVal[0]?.parkingLength !== parkingObj?.parkingLength ||
              latestVal[0]?.description !== parkingObj?.description) {
              
              // console.log("update condition", latestVal[0]);
              const payload = [...updateValCount];
              const updatedParkingObj = {
                ...parkingObj,
                parkingInventoryId: latestVal[0]?.parkingInventoryId,
              };
              payload.push(updatedParkingObj);
              setUpdateValCount(prevEntries => {
                const updatedEntries = [...prevEntries, updatedParkingObj];
                // console.log("updated__entries", updatedEntries);
                return updatedEntries
              });
            }
          }
        } else if (res.data.length > 0 && !isMatch(latestVal[0], parkingObj) && latestVal[0]?.parkingStatusId.status === "Available") {
          // console.log("second condition");
          payload.version = res.data[0]?.version + 1;
          insertRef.current += 1;
        } else if (res.data.length === 0) {
          console.log("third condition");
          payload.version = 1;
          insertRef.current += 1;
        }

        if (typeof payload.version === "number") {
          const addToServerResponse = await addToServer(payload);
          if (addToServerResponse?.is_failed) {
            fieldServerEntriesArray.current = [
              ...fieldServerEntriesArray.current,
              { ...parkingObj, reason: addToServerResponse.reason },
            ];

          }

        }
      }).catch((err) => {
        if (err.message.includes("violates foreign key constraint")) {
          errorTost("ParkingType doesn't exist")
        } else {
          errorTost(err.message)
        }
        console.error("checkParkingInventory", err)
      })

    }
  }

  function addToServer(parkingObj) {
    return new Promise(async (resolve, reject) => {
      try {
        const createParkingResponse = await insertIntoParkingInventory(parkingObj);
        // console.log("createParkingResponse", createParkingResponse);

        if (createParkingResponse.data) {
          presentLoader();
          const pre_count = parseInt(countRef.current);
          countRef.current = parseInt(pre_count + parseInt(createParkingResponse.data.length));
          setUpdateCount(countRef.current);

          if (parseInt(insertRef.current) === parseInt(countRef.current)) {
            successTost("Parking types added successfully!");
            resVal(true)
          }

          dismissLoader();
          resolve({ success: true });
        } else {
          if (createParkingResponse.error.details && createParkingResponse.error.details.includes('already exists')) {
            resolve({
              success: false,
              is_failed: true,
              reason: createParkingResponse.error.details,
            });
            errorTost(createParkingResponse.error.message);
          } else {
            resolve({
              success: false,
              is_failed: true,
              reason: createParkingResponse.error.message,
            });
            errorTost(createParkingResponse.error.message);
          }
          dismissLoader();
        }
      } catch (error) {
        // Handle unexpected errors
        reject(error);
        errorTost(error)
        dismissLoader();
      }
    });
  }


  function validateExcelObj(excelObj) {
    const validation = {
      isValid: true,
      isCalculation: true,
      reason: '',
    };
    if (!excelObj['Parking Type'] || excelObj['Parking Type'] === '') {
      validation.isValid = false;
      validation.reason =
        validation.reason === ''
          ? 'Parking Type is empty'
          : validation.reason + ', Parking Type is empty';
    }
    var toCheckZero = new RegExp('^0+$');
    var numbers = new RegExp(/^(\d*\.\d+|\d+\.?\d*)$/);
    var specialCharacters = /(?=.*[@#$%^&+=!*])/g;
    if (!excelObj['Floor Number'] || excelObj['Floor Number'] === '' || toCheckZero.test(excelObj['Floor Number']) || excelObj['Floor Number'].match(specialCharacters)) {
      validation.isValid = false;
      if (excelObj['Floor Number'].match(specialCharacters) || toCheckZero.test(excelObj['Floor Number'])) {
        validation.reason =
          validation.reason === ''
            ? 'Floor Number must contain numbers and alphabets , cannot contain only zeros'
            : validation.reason + ', Floor Number must contain numbers and alphabets , cannot contain only zeros';
      } else {
        validation.reason =
          validation.reason === ''
            ? 'Floor Number is empty'
            : validation.reason + ', Floor Number is empty';
      }
    }

    if (!excelObj['Parking Number'] || excelObj['Parking Number'] === '' || toCheckZero.test(excelObj['Parking Number'])) {
      validation.isValid = false;
      if (toCheckZero.test(excelObj['Parking Number'])) {
        validation.reason =
          validation.reason === ''
            ? 'Parking Number must contain numbers and alphabets , cannot contain only zeros'
            : validation.reason + ', Parking Number must contain numbers and alphabets , cannot contain only zeros';
      } else {
        validation.reason =
          validation.reason === ''
            ? 'Parking Number is empty'
            : validation.reason + ', Parking Number is empty';
      }
    }


    if (!excelObj.parkingBreadth || excelObj.parkingBreadth === '' || !numbers.test(excelObj.parkingBreadth) || isNaN(excelObj.parkingBreadth)) {
      validation.isValid = false;

      if (!numbers.test(excelObj.parkingBreadth)) {
        validation.reason =
          validation.reason === ''
            ? 'Parking breadth must contain numbers only'
            : validation.reason + ', Parking breadth must contain numbers only';
      } else {
        validation.reason =
          validation.reason === ''
            ? 'Parking breadth is empty'
            : validation.reason + ', Parking breadth is empty';
      }
    }
    if (!excelObj.parkingHeight || excelObj.parkingHeight === '' || !numbers.test(excelObj.parkingHeight) || isNaN(excelObj.parkingHeight)) {
      validation.isValid = false;

      if (!numbers.test(excelObj.parkingHeight) ) {
        validation.reason =
          validation.reason === ''
            ? 'Parking height must contain numbers only'
            : validation.reason + ', Parking height must contain numbers only';
      } else {
        validation.reason =
          validation.reason === ''
            ? 'Parking height is empty'
            : validation.reason + ', Parking height is empty';
      }
    }

    if (!excelObj.parkingLength || excelObj.parkingLength === '' || !numbers.test(excelObj.parkingLength) || isNaN(excelObj.parkingLength)) {
      validation.isValid = false;

      if (!numbers.test(excelObj.parkingLength)) {
        validation.reason =
          validation.reason === ''
            ? 'Parking length must contain numbers only'
            : validation.reason + ', Parking length must contain numbers only';
      } else {
        validation.reason =
          validation.reason === ''
            ? 'Parking length is empty'
            : validation.reason + ', Parking length is empty';
      }
    }

    if ((parseFloat(excelObj.parkingBreadth) === 0 ) && (parseFloat(excelObj.parkingHeight) === 0) && (parseFloat(excelObj.parkingLength) === 0)) {
    validation.isValid = false;
    validation.reason = validation.reason === ''
        ? 'At least one of the parking dimensions must have a non-zero value'
        : validation.reason + ', At least one of the parking dimensions must have a non-zero value';
    }

    if (!excelObj['description'] || excelObj['description'] === '') {
      validation.isValid = false;
      validation.reason =
        validation.reason === ''
          ? 'Description is empty'
          : validation.reason + ', Description is empty';
    }

    return { validation, excelObj };
  }



  const handleUpdateDuplicateEntries = () => {
    presentLoader()
    updateValCount.forEach((val, index) => {
      updateParkingInventory(val).then(() => {
        if (updateValCount?.length === (index + 1)) {
          dismissLoader()
          // setUpdateValCount([])
          successTost("Parking inventory updated successfully!")
          resVal(true)
        }
      }).catch(err => {
        dismissLoader()
        errorTost(err.message)
      })
    })
  }

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose(csvUploaded);
          resVal(true)
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
        sx={[
          { '.MuiBackdrop-root': { background: 'rgba(193, 201, 210, 0.7)' } },
        ]}
        disableAutoFocus={true}
      >
        <Box className={cssClasses.modalWrapper}>
          <div className={cssClasses.header}>
            <h1>Uploading Parking Types</h1>
          </div>

          <div className={cssClasses.mainContainer}>
            <div className={cssClasses.mainContainerWrapper}>
              {/* Step 1 */}
              <div className={cssClasses.progressCardContainer}>
                <Box
                  display={'flex'}
                  flexDirection={'row'}
                  justifyContent={'space-between'}
                  mb={'1rem'}
                  p={'1rem 1.5rem'}
                >
                  <Typography
                    color={'#0F0F0F'}
                    fontSize={'2rem'}
                    lineHeight={'3rem'}
                    fontWeight={400}
                  >
                    Reading Excel
                  </Typography>
                  {stepperValue > 1 ? (
                    <CheckCircleIcon
                      color={'primary'}
                      style={{ width: '2rem', height: '2rem' }}
                    />
                  ) : (
                    <CheckCircleIcon
                      color={'primary'}
                      style={{ width: '2rem', height: '2rem', opacity: '0.5' }}
                    />
                  )}
                </Box>
                {stepperValue > 1 ? (
                  <LinearProgress variant='determinate' value={100} />
                ) : (
                  <LinearProgress />
                )}
              </div>

              {/* Step 2 */}
              <div className={cssClasses.progressCardContainer}>
                <Box
                  display={'flex'}
                  flexDirection={'row'}
                  justifyContent={'space-between'}
                  mb={'1rem'}
                  p={'1rem 1.5rem'}
                >
                  <Typography
                    color={'#0F0F0F'}
                    fontSize={'2rem'}
                    lineHeight={'3rem'}
                    fontWeight={400}
                  >
                    Validating Data in Excel
                  </Typography>
                  {stepperValue > 2 ? (
                    <CheckCircleIcon
                      color={'primary'}
                      style={{ width: '2rem', height: '2rem' }}
                    />
                  ) : (
                    <CheckCircleIcon
                      color={'primary'}
                      style={{ width: '2rem', height: '2rem', opacity: '0.5' }}
                    />
                  )}
                </Box>
                {stepperValue > 2 ? (
                  <LinearProgress variant='determinate' value={100} />
                ) : (
                  <LinearProgress />
                )}
              </div>

              {/* Step 2 */}
              <div className={cssClasses.progressCardContainer}>
                <Box
                  display={'flex'}
                  flexDirection={'row'}
                  justifyContent={'space-between'}
                  mb={'1rem'}
                  p={'1rem 1.5rem'}
                >
                  <Typography
                    color={'#0F0F0F'}
                    fontSize={'2rem'}
                    lineHeight={'3rem'}
                    fontWeight={400}
                  >
                    Uploading Data to Database
                  </Typography>
                  {stepperValue === 3 &&
                    (countRef.current + fieldLocalEntriesArray.length + (totalEntriesCount - (countRef.current + fieldLocalEntriesArray.length))) === totalEntriesCount ? (
                    <CheckCircleIcon
                      color={'primary'}
                      style={{ width: '2rem', height: '2rem' }}
                    />
                  ) : (
                    <CheckCircleIcon
                      color={'primary'}
                      style={{ width: '2rem', height: '2rem', opacity: '0.5' }}
                    />
                  )}
                </Box>
                {stepperValue > 3 ? (
                  <LinearProgress variant='determinate' value={100} />
                ) : stepperValue === 3 ? (
                  <LinearProgress
                    variant='determinate'
                    value={
                      ((countRef.current + fieldLocalEntriesArray.length + (totalEntriesCount - (countRef.current + fieldLocalEntriesArray.length))) === totalEntriesCount) * 100
                    }
                  />

                ) : (
                  <LinearProgress />
                )}
              </div>
              <div
                className={cssClasses.progressCardContainer}
                style={{ padding: '1rem 1.5rem' }}
              >
                <Typography
                  color={'#676767'}
                  fontSize={'2rem'}
                  lineHeight={'3rem'}
                  fontWeight={400}
                >
                  Total Entries : {totalEntriesCount}
                </Typography>
                <Typography
                  color={'#676767'}
                  fontSize={'2rem'}
                  lineHeight={'3rem'}
                  fontWeight={400}
                >

                  New Entries : {countRef.current}
                </Typography>
                <Typography
                  color={'#676767'}
                  fontSize={'2rem'}
                  lineHeight={'3rem'}
                  fontWeight={400}
                >

                  Changed Values : {updateValCount?.length}
                  {/* {console.log("!!!!!!!" , updateValCount)} */}
                </Typography>
                <Typography
                  color={'#676767'}
                  fontSize={'2rem'}
                  lineHeight={'3rem'}
                  fontWeight={400}
                >
                  Failed Entries : {fieldLocalEntriesArray?.length}
                </Typography>
                <Typography
                  color={'#676767'}
                  fontSize={'2rem'}
                  lineHeight={'3rem'}
                  fontWeight={400}
                >
                  Old Entries : {oldEntriesCount.length}
                </Typography>

              </div>
            </div>
          </div>

          <div className={cssClasses.footer}>
            {fieldServerEntriesArray.current &&
              fieldServerEntriesArray.current?.length > 0 && (
                <Box
                  display={'flex'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                >
                  <Typography
                    color={'#0F0F0F'}
                    fontSize={'2rem'}
                    lineHeight={'3rem'}
                    fontWeight={400}
                  >
                    {' '}
                    View Field Entries{' '}
                  </Typography>
                  <Box display={'flex'}>
                    <Button
                      style={{
                        color: '#344054',
                        backgroundColor: '#ffffff',
                        border: '1px solid #E5E7EB',
                      }}
                      btnName={'View'}
                      clicked={() => {
                        setIsFieldEntriesModalOpen(true);
                      }}
                    />
                    <div style={{ marginLeft: '1rem' }}>
                      <Button
                        style={{
                          color: '#344054',
                          backgroundColor: '#ffffff',
                          border: '1px solid #E5E7EB',
                        }}
                        btnName={'Close'}
                        clicked={() => {
                          handleClose(true);
                          resVal(true)
                        }}
                      />
                    </div>
                  </Box>
                </Box>
              )}

            <Box
              display={'flex'}
              flexDirection={'row'}
              justifyContent={'flex-end'}
            >
              {(
                <Box marginRight={'2rem'}>
                  <Button
                    style={{
                      color: '#ffffff',
                      backgroundColor: '#3B82F6',
                      width: 'auto',
                    }}
                    disable={updateValCount?.length === 0}
                    btnName={'Update Previous Entries'}
                    clicked={() => handleUpdateDuplicateEntries()}
                  />
                </Box>
              )}
              {fieldLocalEntriesArray.length > 0 && (
                <Box marginRight={'2rem'}>
                  <Button
                    style={{
                      color: '#ffffff',
                      backgroundColor: '#3B82F6',
                      width: 'auto',
                    }}
                    btnName={'View Failed Entries'}
                    clicked={() => setIsFieldLocalEntriesModalOpen(true)}
                  />
                </Box>
              )}
              <Button
                style={{
                  color: '#ffffff',
                  backgroundColor: '#3B82F6',
                  width: 'auto',
                }}
                btnName={'Close'}
                clicked={() => handleClose(csvUploaded)}
              />
            </Box>
          </div>
        </Box>
      </Modal>

      {isFieldEntriesModalOpen && (
        <ParkingFieldEntriesModal
          open={isFieldEntriesModalOpen}
          handleClose={() => setIsFieldEntriesModalOpen(false)}
          fieldEntriesArray={fieldServerEntriesArray.current?.map((m, i) => ({
            ...m,
            id: i,
          }))}
          DatabaseTotal={totalEntriesCount}
        />
      )}

      {/* //todo -----------> Local Field entries on close modal close all process  */}
      {isFieldLocalEntriesModalOpen && (
        <ParkingFieldEntriesModal
          open={isFieldLocalEntriesModalOpen}
          handleClose={() => {
            setIsFieldLocalEntriesModalOpen(false);
          }}
          fieldEntriesArray={fieldLocalEntriesArray}
          DatabaseTotal={totalEntriesCount}
        />
      )}
    </>
  );
}

export default UploadParkingModal;
